import { Container, Drawer, Grid, styled } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import DrawerTabs from "./Component/DrawerTabs";
import { GetMarketLoggedInList } from "store/api/market";
import SearchInput from "components/SearchInput";
import TableDrawer from "./Component/TableDrawer";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import { search } from "utils/helpers/search";
import useNotify from "hooks/useNotify";

let getMarketLoggedInListInterval = null;

function MarketDrawer({ open, onClose, onRowClick, destinations }) {
  const notify = useNotify();
  const [value, setValue] = useState();

  const [marketList, setMarketList] = useState();
  const [marketTab, setMarketTab] = useState(-1);
  const [marketLoading, setMarketLoading] = useState(false);

  const handleChangeTab = (_, newValue) => {
    setMarketTab(newValue);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const getMarketLoggedInList = async (destSelected) => {
    try {
      const { data } = await http.get(GetMarketLoggedInList(destSelected));
      setMarketList(data?.data);

      setMarketLoading(true);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const repeatGetMarketLoggedInList = () => {
    getMarketLoggedInList(marketTab);

    clearInterval(getMarketLoggedInListInterval);

    getMarketLoggedInListInterval = repeat({
      action: () => getMarketLoggedInList(marketTab),
    });

    return () => {
      clearInterval(getMarketLoggedInListInterval);
    };
  };

  const searchedMarketList = useMemo(() => {
    return search({
      list: marketList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [marketList, value]);

  useEffect(() => {
    if (open) {
      repeatGetMarketLoggedInList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketTab]);

  useEffect(() => {
    if (!open) {
      clearInterval(getMarketLoggedInListInterval);
    } else {
      repeatGetMarketLoggedInList();
    }

    return () => {
      clearInterval(getMarketLoggedInListInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <DrawerStyle anchor="left" open={open} onClose={onClose}>
      <Container>
        <Grid container>
          <DrawerTabs
            destinations={destinations}
            value={marketTab}
            onChange={handleChangeTab}
          />

          <SearchInput value={value} onChange={handleSearch} />

          <TableDrawer
            onRowClick={onRowClick}
            marketList={searchedMarketList}
            loading={marketLoading}
            hideBorders={true}
          />
        </Grid>
      </Container>
    </DrawerStyle>
  );
}

const DrawerStyle = styled(Drawer)(() => ({
  width: "90%",

  ".MuiDrawer-paper": {
    width: "90%",
    maxWidth: "400px",
  },
}));

export default MarketDrawer;
